import { render } from "./BonusYearDetail.vue?vue&type=template&id=3d494ad4&scoped=true"
import script from "./BonusYearDetail.vue?vue&type=script&lang=js"
export * from "./BonusYearDetail.vue?vue&type=script&lang=js"

import "./BonusYearDetail.vue?vue&type=style&index=0&id=3d494ad4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d494ad4"]])

export default __exports__